<script setup lang="ts">
interface Prors {
  src?: string
}
withDefaults(defineProps<Prors>(), {
  src: '',
})
</script>

<template>
  <img class="w-48px h-48px rounded-full lt-tablet:w-40px lt-tablet:h-40px" :src="src">
</template>
